var map = {
	"./invalid.mp3": 716,
	"./plop.mp3": 717
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds nonrecursive \.(aif|mp3)$
// module id = 715
// module chunks = 7